export const getShiftLabel = (shift) => {
  switch (shift) {
    case 1: return "Morning";
    case 2: return "Night";
    default: return "Unknown";
  }
};

export const getPartLabel = (part) => {

  switch (parseInt(part)) {
    case 1: return "First Part";
    case 2: return "Second Part";
    default: return "";
  }
};
